<template>
  <v-card>
    <v-tabs>
      <v-tab>
        table
      </v-tab>
      <v-tab-item>
        <user-permissions-filter-card/>
        <user-permissions-table-card/>
      </v-tab-item>
      <v-tab>
        permission
      </v-tab>
      <v-tab-item>
        <v-card>
          <user-permissions-tag-table/>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import UserPermissionsFilterCard from "@/components/user-permissions/UserPermissionsFilterCard";
import UserPermissionsTableCard from "@/components/user-permissions/UserPermissionsTableCard";
import UserPermissionsTagTable from "@/components/user-permissions/UserPermissionsTagTable";
import {mapActions} from "vuex";

export default {
  name: "UserPermissions",
  components: {
    'user-permissions-filter-card': UserPermissionsFilterCard,
    'user-permissions-table-card': UserPermissionsTableCard,
    'user-permissions-tag-table': UserPermissionsTagTable,
  },
  methods: {
    ...mapActions('userPermissions', ['fetchAllUsersTags']),
    ...mapActions('user', ['fetchAllPermissions']),
  },
  async created() {
    await this.fetchAllUsersTags();
    await this.fetchAllPermissions()
  }
}
</script>

<style scoped>

</style>